// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAmzBFi_KEk_xGC5Mv8CZz8wUZvz9C7sKc',
    authDomain: 'exaess-f1ee9.firebaseapp.com',
    databaseURL: 'https://exaess-f1ee9.firebaseio.com',
    projectId: 'exaess-f1ee9',
    storageBucket: 'exaess-f1ee9.appspot.com',
    messagingSenderId: '622276818206'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
